import { API } from 'utils';
import { GW_SERVICES_PREFIXES } from '../../constants';
import { IParams } from 'http-requests/types';

const { APPEALS, AI, C300 } = GW_SERVICES_PREFIXES;

// ============= Работа с обращениями =============
/** Получение списка обращений */
export const GetAppeals = (params: IParams) =>
  API.get(`/${APPEALS}/appeal/employee/`, undefined, params);

/** Получение обращения по его ID */
export const GetAppealByID = (id: string) =>
  API.get(`/${APPEALS}/appeal/employee/`, id);

/** Получение количество обращений по каждому статусу */
export const GetAppealsStats = () =>
  API.get(`/${APPEALS}/appeal/employee/stats/`);

/** Создание обращения */
export const CreateAppeal = (params: IParams) =>
  API.gatewayPost(`/${APPEALS}/appeal/employee/`, params);

/** Обновление обращения */
export const UpdateAppeal = (appealID: string, params: IParams) =>
  API.gatewayPatch(`/${APPEALS}/appeal/employee/`, appealID, params);

/** Удаление обращения */
export const DeleteAppeal = (id: string) =>
  API.gatewayDelete(`/${APPEALS}/appeal/employee/`, id);

/** Ответ не требуется */
export const NoAnwerReason = (id: string, params: IParams) =>
  API.gatewayPatch(
    `/${APPEALS}/appeal/employee/${id}/no_answer/`,
    undefined,
    params
  );

/** Принятие обращения */
export const AcceptAppeal = (appealID: string) =>
  API.gatewayPatch(`/${APPEALS}/appeal/employee/${appealID}/accept/`);

/** Преобразование в заявку */
export const ConvertToRequest = (appealID: string) =>
  API.gatewayPost(
    `/${APPEALS}/appeal/employee/${appealID}/convert_to_request/`
  );

// ============= Категории обращений =============
/** Получение списка категорий у организации */
export const GetAppealCategories = () =>
  API.get(`/${APPEALS}/appeal/category/`);

/** Создание категории */
export const CreateAppealCategory = (params: IParams) =>
  API.gatewayPost(`/${APPEALS}/appeal/category/`, params);

/** Обновление категории */
export const UpdateAppealCategory = (id: string, params: IParams) =>
  API.gatewayPatch(`/${APPEALS}/appeal/category/`, id, params);

/** Удаление категории */
export const DeleteAppealCategory = (id: string) =>
  API.gatewayDelete(`/${APPEALS}/appeal/category/`, id);

// ============= Ответы на обращения =============
/** Сохранить ответ на обращение */
export const SaveAppealAnswer = (appealID: string, params: IParams) =>
  API.gatewayPost(`/${APPEALS}/appeal/employee/${appealID}/answers/`, params);

/** Обновить сохраненный ответ на обращение */
export const UpdateSavedAppealAnswer = (
  appealID: string,
  answerID: string,
  params: IParams
) =>
  API.gatewayPatch(
    `/${APPEALS}/appeal/employee/${appealID}/answers/${answerID}/`,
    undefined,
    params
  );

/** Публикация ответа на обращение */
export const PublishAppealAnswer = (appealID: string, answerID: string) =>
  API.gatewayPatch(
    `/${APPEALS}/appeal/employee/${appealID}/answers/${answerID}/publish/`
  );

// ============= Комментарии к обращениям =============
/** Получить комментарии к обращению */
export const GetComments = (appealID: string) =>
  API.get(`/${APPEALS}/appeal/employee/${appealID}/comments/`);

/** Отправить комментарий к обращению */
export const SendComment = (appealID: string, params: IParams) =>
  API.gatewayPost(`/${APPEALS}/appeal/employee/${appealID}/comments/`, params);

/** Прочтение комментария обращения */
export const ReadComment = (appealID: string, commentID: string) =>
  API.gatewayPatch(
    `/${APPEALS}/appeal/employee/${appealID}/comments/${commentID}/read/`
  );

// ============= Темы с ГИС =============
/** Получение списка тем */
export const GetTopics = () => API.get(`/${APPEALS}/appeal/topic/`);

// ============= Сторонние лица =============
/** Получение списка сторонних лиц */
export const GetOtherPersons = (params: { phone_number: string }) =>
  API.get(`/${APPEALS}/others/person/`, undefined, params);

/** Создание стороннего лица */
export const CreateOtherPerson = (params: IParams) =>
  API.gatewayPost(`/${APPEALS}/others/person/`, params);

/** Обновление стороннего лица */
export const UpdateOtherPerson = (id: string, params: IParams) =>
  API.gatewayPatch(`/${APPEALS}/others/person/`, id, params);

/** Получение списка сотрудников */
export const GetOtherEmployees = (params?: IParams) =>
  API.get(`/${APPEALS}/others/employee/`, undefined, params);

/** Создание сотрудника */
export const CreateOtherEmployee = (params: IParams) =>
  API.gatewayPost(`/${APPEALS}/others/employee/`, params);

/** Обновление сотрудника */
export const UpdateOtherEmployee = (id: string, params: IParams) =>
  API.gatewayPatch(`/${APPEALS}/others/employee/`, id, params);

/** Получение списка организаций */
export const GetOtherProviders = (params: { phone_number: string }) =>
  API.get(`/${APPEALS}/others/provider/`, undefined, params);

/** Создание организации */
export const CreateOtherProvider = (params: IParams) =>
  API.gatewayPost(`/${APPEALS}/others/provider/`, params);

// ============= Синхронизация с ГИС =============
/** Удаление предупреждения о синхронизации с ГИС */
export const DeleteUnconfirmedChange = (appealID: string) =>
  API.gatewayPatch(
    `/${APPEALS}/appeal/employee/${appealID}/delete_unconfirmed_change/`
  );

// ============= Отчеты =============
/** Excel отчет по обращениям */
export const DownloadXLSXReport = (params: IParams) =>
  API.gatewayUnparsedGet(
    `/${APPEALS}/appeal/employee/xlsx_report/`,
    undefined,
    params
  );

/** Сгенерировать текст по стилю, или исправить опечатки */
export const GenerateAiAnswer = (params: IParams) =>
  API.gatewayPost(`/${AI}/ml/llm/appeal-text-editor`, params);

/** Отправить запрос на подключения ИИ-редактора */
export const CreateAiTicket = () =>
  API.gatewayPost(`/${C300}/models/support_ticket/ai/redactor_ticket/`);

/** Проверить статус сообщения на подключение ИИ-редактора */
export const CheckAiTicketStatus = (): Promise<{
  alert: string;
  text: string;
}> => API.get(`/${C300}/models/support_ticket/ai/status/`);

/** Условие показа функционала "Наш Санкт-Петербург" **/
export const GetOurSPBAvailability = () =>
  API.get(`/${APPEALS}/appeal/employee/our_spb_availability/`);

/** Получение других обращений по этой проблеме (с портала "Наш Санкт-Петербург") **/
export const GetAppealsWithSameProblem = (problemNumber: string) =>
  API.get(`/${APPEALS}/appeal/employee/by_problem/`, undefined, {
    problem_number: problemNumber,
  });
